import { render, staticRenderFns } from "./CorrPricerModal.vue?vue&type=template&id=67572041&scoped=true&"
import script from "./CorrPricerModal.vue?vue&type=script&lang=js&"
export * from "./CorrPricerModal.vue?vue&type=script&lang=js&"
import style0 from "./CorrPricerModal.vue?vue&type=style&index=0&id=67572041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67572041",
  null
  
)

export default component.exports